var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "table-wrapper", class: { "is-edit": _vm.editMode } },
    [
      _c("div", { staticClass: "table-header" }, [
        _vm._v("\n    " + _vm._s(_vm.title) + "\n  ")
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table-body", staticStyle: { "overflow-x": "auto" } },
        [
          _c("table", { staticClass: "table" }, [
            _c("thead", [
              _c(
                "tr",
                [
                  _vm.editMode ? _c("th", [_vm._v("   ")]) : _vm._e(),
                  _vm._v(" "),
                  _vm.editMode
                    ? _c("th", { staticClass: "text-center" }, [
                        _vm._v(" Projet ")
                      ])
                    : [
                        _c(
                          "th",
                          {
                            staticStyle: {
                              "white-space": "nowrap",
                              width: "75px"
                            }
                          },
                          [_vm._v("# Projet")]
                        ),
                        _vm._v(" "),
                        _c("th", [_vm._v("Nom du projet")])
                      ],
                  _vm._v(" "),
                  _vm.editMode
                    ? _c("th", { staticClass: "text-center" }, [
                        _vm._v(" Phase ")
                      ])
                    : [
                        _c(
                          "th",
                          {
                            staticClass: "text-center",
                            staticStyle: {
                              "white-space": "nowrap",
                              width: "50px"
                            }
                          },
                          [_vm._v("Phase")]
                        ),
                        _vm._v(" "),
                        _c("th", { staticStyle: { width: "10%" } }, [
                          _vm._v("Nom phase")
                        ])
                      ],
                  _vm._v(" "),
                  _vm.editMode
                    ? _c("th", { staticClass: "text-center" }, [
                        _vm._v(" " + _vm._s(_vm.activityNameLabel) + " ")
                      ])
                    : [
                        _c(
                          "th",
                          {
                            staticClass: "text-center",
                            staticStyle: {
                              "white-space": "nowrap",
                              width: "50px"
                            }
                          },
                          [_vm._v(_vm._s(_vm.activityNumberLabel))]
                        ),
                        _vm._v(" "),
                        _c("th", { staticStyle: { width: "10%" } }, [
                          _vm._v(_vm._s(_vm.activityNameLabel))
                        ])
                      ],
                  _vm._v(" "),
                  _vm._l(_vm.days, function(day, index) {
                    return _c(
                      "th",
                      {
                        key: index,
                        staticClass: "text-center",
                        staticStyle: { width: "50px" }
                      },
                      [
                        _vm._v(
                          "\n            " + _vm._s(day.dateOfMonth) + " "
                        ),
                        _c("br"),
                        _vm._v(" " + _vm._s(day.dayShort) + "\n          ")
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "th",
                    {
                      staticClass: "text-center",
                      staticStyle: { width: "50px" }
                    },
                    [_vm._v("Total")]
                  ),
                  _vm._v(" "),
                  _c("th", [_vm._v("Commentaire")])
                ],
                2
              )
            ]),
            _vm._v(" "),
            _c(
              "tbody",
              [
                _vm._l(_vm.rows, function(row, index) {
                  return [
                    _c(
                      "tr",
                      {
                        key: index,
                        staticClass: "timesheet-entry-row",
                        class:
                          row.timesheet_entry_is_adjustment == "1"
                            ? "timesheet-entry-adjustment"
                            : ""
                      },
                      [
                        _vm.editMode
                          ? _c("td", { staticStyle: { width: "1%" } }, [
                              !row.partial &&
                              row.timesheet_entry_is_adjustment != "1"
                                ? _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-sm btn-danger",
                                      staticStyle: { "margin-right": "0" },
                                      on: {
                                        click: function($event) {
                                          return _vm.deleteRowAsk(row)
                                        }
                                      }
                                    },
                                    [_c("i", { staticClass: "fa fa-trash" })]
                                  )
                                : _vm._e()
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.editMode
                          ? _c(
                              "td",
                              { staticClass: "text-center" },
                              [
                                _c("select2", {
                                  ref: "rowProjectSelect2",
                                  refInFor: true,
                                  staticClass:
                                    "text-left timesheet-entry-project",
                                  attrs: {
                                    placeholder: "Sélectionner",
                                    endpoint: _vm.projectSelect2Endpoint,
                                    value:
                                      row.project_id == null
                                        ? undefined
                                        : {
                                            id: row.project_id,
                                            text:
                                              row.project_number +
                                              " - " +
                                              row.project_name
                                          },
                                    renderMethod: _vm.projectRenderMethod,
                                    disabled:
                                      row.timesheet_entry_is_adjustment == "1"
                                  },
                                  on: {
                                    selected: function($event) {
                                      return _vm.projectSelected(row, $event)
                                    },
                                    clear: function($event) {
                                      return _vm.projectSelected(row, null)
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          : [
                              _c("td", { staticClass: "text-center" }, [
                                _vm._v(_vm._s(row.project_number))
                              ]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(row.project_name))])
                            ],
                        _vm._v(" "),
                        _vm.editMode
                          ? _c(
                              "td",
                              {
                                staticClass: "text-center",
                                staticStyle: { width: "200px" }
                              },
                              [
                                _c("select2", {
                                  ref: "rowPhaseSelect2",
                                  refInFor: true,
                                  staticClass:
                                    "text-left timesheet-entry-phase",
                                  attrs: {
                                    placeholder: "Sélectionner",
                                    endpoint: _vm.phaseSelect2Endpoint,
                                    attributes: { project_id: row.project_id },
                                    value:
                                      row.project_phase_id == null
                                        ? undefined
                                        : {
                                            id: row.project_phase_id,
                                            text:
                                              row.project_phase_number +
                                              " - " +
                                              row.project_phase_description
                                          },
                                    disabled:
                                      row.timesheet_entry_is_adjustment == "1"
                                  },
                                  on: {
                                    selected: function($event) {
                                      return _vm.phaseSelected(row, $event)
                                    },
                                    clear: function($event) {
                                      return _vm.phaseSelected(row, null)
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          : [
                              _c("td", { staticClass: "text-center" }, [
                                _vm._v(_vm._s(row.project_phase_number))
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(_vm._s(row.project_phase_description))
                              ])
                            ],
                        _vm._v(" "),
                        _vm.editMode && _vm.displayActivityInputs
                          ? _c(
                              "td",
                              {
                                staticClass: "text-center",
                                staticStyle: { width: "200px" }
                              },
                              [
                                _c("select2", {
                                  ref: "rowActivitySelect2",
                                  refInFor: true,
                                  staticClass:
                                    "text-left timesheet-entry-activity",
                                  attrs: {
                                    placeholder: "Sélectionner",
                                    endpoint: _vm.activitySelect2Endpoint,
                                    value:
                                      row.activity_id == null
                                        ? undefined
                                        : {
                                            id: row.activity_id,
                                            text:
                                              row.activity_number +
                                              " - " +
                                              row.activity_name
                                          },
                                    disabled:
                                      row.timesheet_entry_is_adjustment == "1"
                                  },
                                  on: {
                                    selected: function($event) {
                                      return _vm.activitySelected(row, $event)
                                    },
                                    clear: function($event) {
                                      return _vm.activitySelected(row, null)
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          : _vm.displayActivityInputs
                          ? [
                              _c("td", { staticClass: "text-center" }, [
                                _vm._v(_vm._s(row.activity_number))
                              ]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(row.activity_name))])
                            ]
                          : _c(
                              "td",
                              { attrs: { colspan: _vm.editMode ? 1 : 2 } },
                              [_vm._v(" ")]
                            ),
                        _vm._v(" "),
                        _vm._l(_vm.days, function(day, index2) {
                          return _c(
                            "td",
                            {
                              key: index + "_" + index2,
                              staticStyle: {
                                "white-space": "nowrap",
                                width: "30px"
                              }
                            },
                            [
                              _vm.editMode
                                ? _c("div", [
                                    _c("input", {
                                      staticClass:
                                        "input-text-fancy input-sm input-right timesheet-entry-value",
                                      attrs: {
                                        type: "text",
                                        disabled:
                                          row.timesheet_entry_is_adjustment ==
                                          "1"
                                      },
                                      domProps: {
                                        value: _vm.formatDigit(
                                          _vm.dayValue(row.days[day.date]),
                                          _vm.valueDecimals
                                        )
                                      },
                                      on: {
                                        change: function($event) {
                                          return _vm.rowUpdated(row, {
                                            day: {
                                              date: day.date,
                                              value: $event.target.value
                                            }
                                          })
                                        },
                                        click: function($event) {
                                          return $event.target.select()
                                        }
                                      }
                                    })
                                  ])
                                : _c(
                                    "div",
                                    {
                                      staticClass: "text-center",
                                      staticStyle: { padding: "0 3px" }
                                    },
                                    [
                                      _vm.dayValue(row.days[day.date]) != ""
                                        ? _c("span", [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.formatDigit(
                                                    _vm.dayValue(
                                                      row.days[day.date]
                                                    ),
                                                    _vm.valueDecimals
                                                  )
                                                ) +
                                                "\n                "
                                            )
                                          ])
                                        : _c("span", [
                                            _vm._v(
                                              "\n                   \n                "
                                            )
                                          ])
                                    ]
                                  )
                            ]
                          )
                        }),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticClass: "text-right",
                            staticStyle: {
                              "white-space": "nowrap",
                              width: "1%"
                            },
                            attrs: { rowspan: "2" }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.formatDigit(
                                  _vm.rowTotal(row),
                                  _vm.valueDecimals
                                )
                              )
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticStyle: { width: "25%" },
                            attrs: { rowspan: "2" }
                          },
                          [
                            _vm.editMode
                              ? _c("div", [
                                  _c("input", {
                                    staticClass: "form-control",
                                    attrs: {
                                      type: "text",
                                      disabled:
                                        row.timesheet_entry_is_adjustment == "1"
                                    },
                                    domProps: {
                                      value: row.timesheet_entry_comment
                                    },
                                    on: {
                                      change: function($event) {
                                        return _vm.rowUpdated(row, {
                                          timesheet_entry_comment:
                                            $event.target.value
                                        })
                                      }
                                    }
                                  })
                                ])
                              : _c("div", [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(row.timesheet_entry_comment) +
                                      "\n              "
                                  )
                                ])
                          ]
                        )
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c("tr", { staticClass: "timesheet-entry-row-error" }, [
                      _c("td"),
                      _vm._v(" "),
                      _vm._m(0, true),
                      _vm._v(" "),
                      _vm._m(1, true),
                      _vm._v(" "),
                      _vm._m(2, true),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "timesheet-entry-value",
                          attrs: { colspan: _vm.days.length }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "custom-error",
                              staticStyle: { display: "none" }
                            },
                            [_vm._v("Veuillez saisir au moins un temps")]
                          )
                        ]
                      )
                    ])
                  ]
                }),
                _vm._v(" "),
                _c(
                  "tr",
                  [
                    _c("td", { attrs: { colspan: _vm.editMode ? 3 : 5 } }),
                    _vm._v(" "),
                    _c("td", { staticClass: "bold text-center" }, [
                      _vm._v("Total")
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.days, function(day, index) {
                      return _c(
                        "td",
                        {
                          key: index,
                          staticClass: "text-right",
                          staticStyle: {
                            "white-space": "nowrap",
                            width: "30px"
                          }
                        },
                        [
                          _c("span", { staticStyle: { padding: "0 3px" } }, [
                            _vm._v(
                              _vm._s(
                                _vm.formatDigit(
                                  _vm.dayTotal(day),
                                  _vm.valueDecimals
                                )
                              )
                            )
                          ])
                        ]
                      )
                    }),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticClass: "text-right bold",
                        staticStyle: { "white-space": "nowrap", width: "1%" }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.formatDigit(_vm.grandTotal, _vm.valueDecimals)
                          )
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("td", { staticStyle: { width: "25%" } }, [
                      _vm._v(_vm._s(_vm.commentText))
                    ])
                  ],
                  2
                )
              ],
              2
            )
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { staticClass: "timesheet-entry-project" }, [
      _c(
        "div",
        { staticClass: "custom-error", staticStyle: { display: "none" } },
        [_vm._v("Champs requis")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { staticClass: "timesheet-entry-phase" }, [
      _c(
        "div",
        { staticClass: "custom-error", staticStyle: { display: "none" } },
        [_vm._v("Champs requis")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { staticClass: "timesheet-entry-activity" }, [
      _c(
        "div",
        { staticClass: "custom-error", staticStyle: { display: "none" } },
        [_vm._v("Champs requis")]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }